interface ShortcutDefinition {
  key: string;
  description: string;
}

export const SHORTCUTS = {
  FOCUS_CHAT_INPUT: { key: '$mod+k', description: 'Focus chat input' },
  TOGGLE_SIDEBAR: { key: '$mod+b', description: 'Toggle sidebar' },
  HOME: { key: '$mod+Shift+f', description: 'Home' },
  TOGGLE_INTERRUPTION: { key: 'Escape', description: 'Toggle interruption' },
  APPROVE_ACTION: { key: '$mod+y', description: 'Approve action' },
  RESUME_STREAM: { key: 'Shift+Enter', description: 'Resume stream' },
  CONFIRM_INTERRUPTION: { key: 'Shift+Enter', description: 'Confirm stop' },
  CANCEL_INTERRUPTION: { key: 'Escape', description: 'Cancel stop' },
} as const satisfies Record<string, ShortcutDefinition>;

export type ShortcutId = keyof typeof SHORTCUTS;

const isMac = (): boolean => {
  if (typeof window === 'undefined') return false;
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};

export function getShortcutDisplay(id: ShortcutId): string {
  const shortcut = SHORTCUTS[id];
  const key = shortcut.key;

  const mac = isMac();
  let display = key
    .replace('$mod', mac ? '⌘' : 'Ctrl')
    .replace('Shift', mac ? '⇧' : 'Shift')
    .replace('Alt', mac ? '⌥' : 'Alt')
    .replace('Control', mac ? '⌃' : 'Ctrl');

  if (mac) {
    display = display.replace(/\+/g, '');
  }

  return display;
}

export function getShortcutKey(id: ShortcutId): string {
  return SHORTCUTS[id].key;
}
